import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import {
  GoodbyeScreen,
  LoginScreen,
  SecuredRoute,
  OnboardingScreen,
  GroupLoginScreen,
  AppRouter,
  AuditRouter,
  ImpersonateScreen,
} from 'screens';
import { DevelopmentMenu } from 'services/developer';

export const App = () => {
  return (
    <div className="App">
      <Switch>
        <Route path="/not-available" component={GoodbyeScreen} />
        <Redirect from="*" to="/not-available" />
        
        <SecuredRoute path={'/profile/:userId'} component={AppRouter} />
        <SecuredRoute path={'/manage-apps'} component={AppRouter} />
        <SecuredRoute path={'/search/:qs'} component={AppRouter} />
        <SecuredRoute path={'/group/:groupId'} component={AppRouter} />
        <SecuredRoute path={'/integration/:integrationType'} component={AppRouter} />
        <SecuredRoute path={'/folder/:folderId'} component={AppRouter} />
        <SecuredRoute path={'/settings'} component={AppRouter} />
        <SecuredRoute exact path={'/dsa'} component={AuditRouter} />
        <SecuredRoute exact path={'/dsa/outside-organization'} component={AuditRouter} />
        <SecuredRoute exact path={'/dsa/personal-accounts'} component={AuditRouter} />
        <SecuredRoute exact path={'/dsa/outside-ownership'} component={AuditRouter} />
        <SecuredRoute exact path={'/dsa/open-links'} component={AuditRouter} />
        <SecuredRoute path={'/onboarding/:step?'} component={OnboardingScreen} />
        <SecuredRoute path="/logout" component={AppRouter} />
        <SecuredRoute exact path={'/subscription-playground'} component={AppRouter} />
        <SecuredRoute path={'/impersonate/:accessToken'} component={ImpersonateScreen} />
        <Route path="/developer" component={DevelopmentMenu} />
        <Route path="/group-invite/:groupId" component={GroupLoginScreen} />
        <Route path="/login" component={LoginScreen} />
        <SecuredRoute path="/" component={AppRouter} />
      </Switch>
      <div id="portals" />
    </div>
  );
};
